var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "84.456",
        height: "84.453",
        viewBox: "297.216 150.694 84.456 84.453",
      },
    },
    [
      _c("g", { attrs: { "data-name": "Group 175" } }, [
        _c("path", {
          attrs: {
            d: "M327.15 157.011a4.95 4.95 0 1 0 0 9.9 4.95 4.95 0 0 0 0-9.9Z",
            "fill-rule": "evenodd",
            fill: 'url("#a")',
            transform: "translate(34.652 8.761)",
            "data-name": "Path 350",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M327.137 159.671c-11.467 0-20.798 9.33-20.798 20.798 0 11.469 9.33 20.8 20.798 20.8 11.469 0 20.797-9.331 20.797-20.8 0-11.467-9.328-20.798-20.797-20.798Zm0 34.122c-7.347 0-13.324-5.977-13.324-13.324 0-7.347 5.977-13.322 13.324-13.322 7.347 0 13.321 5.975 13.321 13.322 0 7.347-5.974 13.324-13.321 13.324Z",
            "fill-rule": "evenodd",
            fill: 'url("#b")',
            transform: "translate(12.653 12.45)",
            "data-name": "Path 351",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M356.3 235.147h-33.715c-13.988 0-25.369-11.378-25.369-25.366v-33.72c0-13.988 11.381-25.367 25.369-25.367H356.3c13.99 0 25.37 11.379 25.37 25.366v33.72c0 13.989-11.38 25.367-25.37 25.367Zm-33.715-76.51c-9.608 0-17.423 7.816-17.423 17.423v33.72c0 9.606 7.815 17.423 17.423 17.423H356.3c9.607 0 17.424-7.817 17.424-17.422v-33.72c0-9.608-7.817-17.423-17.424-17.423h-33.716Z",
            "fill-rule": "evenodd",
            fill: 'url("#c")',
            "data-name": "Path 352",
          },
        }),
      ]),
      _vm._v(" "),
      _c(
        "defs",
        [
          _c(
            "linearGradient",
            {
              attrs: {
                x1: "-3.408",
                y1: "-3.24",
                x2: "4.328",
                y2: "4.164",
                id: "a",
              },
            },
            [
              _c("stop", {
                attrs: { "stop-color": "#fbe18a", offset: ".001" },
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { "stop-color": "#fcbb45", offset: ".209" },
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { "stop-color": "#f75274", offset: ".376" },
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { "stop-color": "#d53692", offset: ".524" },
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { "stop-color": "#8f39ce", offset: ".739" },
              }),
              _vm._v(" "),
              _c("stop", { attrs: { "stop-color": "#5b4fe9", offset: "1" } }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "linearGradient",
            {
              attrs: {
                x1: "-.421",
                y1: "-.381",
                x2: "1.421",
                y2: "1.381",
                id: "b",
              },
            },
            [
              _c("stop", {
                attrs: { "stop-color": "#fbe18a", offset: ".001" },
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { "stop-color": "#fcbb45", offset: ".209" },
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { "stop-color": "#f75274", offset: ".376" },
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { "stop-color": "#d53692", offset: ".524" },
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { "stop-color": "#8f39ce", offset: ".739" },
              }),
              _vm._v(" "),
              _c("stop", { attrs: { "stop-color": "#5b4fe9", offset: "1" } }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "linearGradient",
            {
              attrs: {
                x1: ".049",
                y1: ".068",
                x2: ".956",
                y2: ".936",
                id: "c",
              },
            },
            [
              _c("stop", {
                attrs: { "stop-color": "#fbe18a", offset: ".001" },
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { "stop-color": "#fcbb45", offset: ".209" },
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { "stop-color": "#f75274", offset: ".376" },
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { "stop-color": "#d53692", offset: ".524" },
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { "stop-color": "#8f39ce", offset: ".739" },
              }),
              _vm._v(" "),
              _c("stop", { attrs: { "stop-color": "#5b4fe9", offset: "1" } }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }